export const whyLiftFilterLego = [
	{
		icon: '✅',
		title: 'whyLift.title1',
		subtitle: 'whyLift.subtitle1',
	},
	{
		icon: '✅',
		title: 'whyLift.title2',
		subtitle: 'whyLift.subtitle2',
	},
	{
		icon: '✅',
		title: 'whyLift.title3',
		subtitle: 'whyLift.subtitle3',
	},
	{
		icon: '✅',
		title: 'whyLift.title4',
		subtitle: 'whyLift.subtitle4',
	},
];
